import axios from 'axios'
import getConfig from 'config/web'

// Client specifically for calls to the user service
const { storeApiUrl: baseURL } = getConfig()

const storeServiceClient = axios.create({
    baseURL,
    headers: {
        Accept: 'application/json',
    },
})

export default storeServiceClient
